import {useParams} from "react-router-dom"
import {useFetchIssueDB} from "../../../hooks/useFetchIssueDB"
import {Empty} from "../../../components/Issues/Empty"
import {ListIssues} from "../../../components/Issues/ListIssues"


export const Issues = () => {
  const {repoId} = useParams()
  const {issueDB, issueReplCnt, setIssueReplCnt} = useFetchIssueDB(repoId)

  if (!issueDB || issueReplCnt === undefined) {
    return null
  }

  const isEmpty = Object.keys(issueDB.all).length === 0

  return (
    isEmpty
      ? <Empty db={issueDB} dbReplCnt={issueReplCnt} setDBReplCnt={setIssueReplCnt}/>
      : <ListIssues db={issueDB} dbReplCnt={issueReplCnt} setDBReplCnt={setIssueReplCnt}/>
  )
}
